import type { ComponentProps } from 'react';
import { MoreHorizontal, Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

interface AgentChatRowProps {
  title: string;
  description?: string;
  selected: boolean;
  disabled: boolean;
  onSelect: () => void;
  onRename?: () => void;
  onDelete?: () => void;
  onCloseAutoFocus?: ComponentProps<typeof DropdownMenuContent>['onCloseAutoFocus'];
}

/** Shared presentation only; each chat owner keeps its own permissions and writes. */
export function AgentChatRow({ title, description, selected, disabled, onSelect, onRename, onDelete, onCloseAutoFocus }: AgentChatRowProps) {
  return <div className="flex min-w-0 items-center gap-1">
    <Button variant={selected ? 'secondary' : 'ghost'}
      className={cn('h-11 min-w-0 flex-1 justify-start rounded-md border px-2 text-left text-xs sm:h-8', selected ? 'border-border' : 'border-transparent')}
      disabled={disabled} aria-current={selected ? 'page' : undefined} aria-description={description}
      title={description ? title + '\n' + description : title} onClick={onSelect}>
      <span className="block min-w-0 truncate">{title}</span>
    </Button>
    {(onRename || onDelete) && <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" size="icon" variant="ghost" className="size-11 shrink-0 sm:size-8"
          aria-label={'Chat actions for ' + title} title="Chat actions" disabled={disabled}>
          <MoreHorizontal className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onCloseAutoFocus={onCloseAutoFocus}>
        {onRename && <DropdownMenuItem disabled={disabled} onSelect={onRename}><Pencil className="size-4" />Rename</DropdownMenuItem>}
        {onDelete && <DropdownMenuItem disabled={disabled} onSelect={onDelete}><Trash2 className="size-4" />Delete</DropdownMenuItem>}
      </DropdownMenuContent>
    </DropdownMenu>}
  </div>;
}
